import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = loading, false = anon
    const [token, setToken] = useState(localStorage.getItem("bio_token"));

    useEffect(() => {
        let active = true;
        async function check() {
            if (!token) {
                if (active) setUser(false);
                return;
            }
            try {
                const { data } = await api.get("/auth/me");
                if (active) setUser(data);
            } catch {
                localStorage.removeItem("bio_token");
                if (active) {
                    setToken(null);
                    setUser(false);
                }
            }
        }
        check();
        return () => {
            active = false;
        };
    }, [token]);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        localStorage.setItem("bio_token", data.token);
        setToken(data.token);
        setUser(data.user);
        return data.user;
    };

    const logout = async () => {
        try {
            await api.post("/auth/logout");
        } catch {
            /* ignore */
        }
        localStorage.removeItem("bio_token");
        setToken(null);
        setUser(false);
    };

    return (
        <AuthContext.Provider value={{ user, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
